<template>
  <div class="search-condition">
    <div class="search-condition__left">
      <div class="search-condition__tips" v-if="groupCheckBox">表头显示字段，可拖动排序</div>
      <div class="search-condition__tips" v-else>*查询条件，取消则移除，可拖动排序</div>
      <!-- <div class="search-condition__tips" v-else>*最多显示{{max}}个查询条件，取消则移除，可拖动排序</div> -->
      <div>
        <el-checkbox-group v-model="form.checkList" @change="leftChange" :disabled="leftItems.length===2">
          <draggable v-model="leftItems" @change="dragChange" v-bind="dragOptions">
            <el-checkbox :label="item[props.id]" v-for="(item,index) in leftItems" :key="index" :disabled="!!item.isFixed && !isDev">{{index+1}}、{{item[props.label]}}</el-checkbox>
          </draggable>
        </el-checkbox-group>
      </div>
    </div>
    <div class="search-condition__middle"></div>
    <div class="search-condition__right">
      <div class="search-condition__tips" v-if="groupCheckBox">未显示字段，选中即显示</div>
      <div class="search-condition__tips" v-else>可添加的查询条件，选中即添加</div>
      <div class="search-condition__search">
        <el-input type="text" v-model="form.value" placeholder="请输入字段关键字检索" clearable suffix-icon="el-icon-search"
          @clear="clear" @keyup.enter.native="searchCheckBox"></el-input>&nbsp;
        <el-button type="primary" @click="searchCheckBox">检索</el-button>
      </div>
      <div class="search-condition-box">
        <el-checkbox-group v-model="form.checkList" @change="handleCheckedFieldsChange" v-if="!groupCheckBox" :disabled="leftItems.length===+max">
          <el-checkbox :label="item[props.id]" v-for="(item,index) in rightItems" :key="index">
            {{item[props.label]}}
            <el-tooltip class="item" effect="dark" placement="top" v-if="[1648,1402,1553,4054].includes(item[props.id])">
              <template #content>
                日期区间和日期时间段互斥（两者只可选其中一种）
              </template>
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </el-checkbox>
        </el-checkbox-group>
        <template v-for="(item,index) in rightItems" v-else>
          <!-- <div class="search-condition__checkbox__title" :key="index"><el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange($event,item)">{{item[props.groupName] | groupName}}</el-checkbox></div> -->
          <div class="search-condition__checkbox__title" :key="index">{{item[props.groupName] | groupName}}</div>
          <div class="search-condition__checkbox__items" :key="`_${index}`">
            <el-checkbox-group v-model="item[props.checked]" @change="handleCheckedFieldsChange($event,item)">
              <template v-for="(child) in item[props.children]">
                <el-checkbox :label="child[props.id]" :key="`_checkbox_${child[props.id]}`">{{child[props.label]}}</el-checkbox>
              </template>
            </el-checkbox-group>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { unique } from '@/utils'
export default {
  name: 'yblCondition',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    props: {
      type: Object,
      default () {
        return {label: 'showName', id: 'id', children: 'children', groupName: 'groupName', groupId: 'groupId', 'checked': 'checkedItems'}
      }
    },
    fields: { // 可配置的字段
      type: Array,
      default: () => []
    },
    checked: { // 已设置字段
      type: Array,
      default: () => []
    },
    max: { // 设置最多显示查询条件
      type: Number | String,
      default: () => 1000
    },
    groupCheckBox: { // 右侧是否GroupCheckBox 显示
      type: Boolean,
      default: () => true
    },
    isFeiChe: { // 是否非车
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      form: {
        checkList: [],
        value: ''
      },
      leftItems: [],
      rightItems: [...this.fields],
      isDev: false// process.env.NODE_ENV === 'development'
    }
  },
  created () {
    // console.log(this.fields, this.checked)
    let id = this.props.id
    this.leftItems = [...this.checked]
    this.form.checkList = unique(this.checked.map(_item => _item[id]))
    if (this.groupCheckBox) {
      this.renderRightItems()
    } else {
      this.rightItems = this.rightItems.filter(item => !this.form.checkList.includes(item[id]))
    }
  },
  computed: {
    dragOptions () {
      return {
        disabled: false
      }
    }
  },
  components: {
    draggable
  },
  methods: {
    leftChange (val) {
      let index = this.leftItems.findIndex(item => !val.includes(item[this.props.id]))
      let _item = this.leftItems.find(item => !val.includes(item[this.props.id]))
      index !== -1 && this.leftItems.splice(index, 1)
      let _rightItems = this.rightItems
      if (this.groupCheckBox) {
        _rightItems = this.rightItems.find(item => item[this.props.groupName] === _item[this.props.groupName])
        _rightItems && _rightItems[this.props.children].push(_item)
        return
      }
      _item && _rightItems.push(_item)
    },
    renderRightItems () {
      let rightOriginFields = [...this.fields]
      this.rightItems = rightOriginFields.filter(item => item.isShow === 1).map(item => {
        item[this.props.children] = item[this.props.children].filter(child => !this.form.checkList.includes(child[this.props.id]))
        return item
      })
    },
    handleCheckAllChange (val, item) {
      item[this.props.checked] = val ? item[this.props.children].map(item => item[this.props.id]) : []
      item.isIndeterminate = false
      if (val) {
        let len = this.leftItems.length
        let _len = item[this.props.children].length
        if (len + _len > +this.max && !this.groupCheckBox) {
          this.$alert(`查询条件最多显示${this.max}条`)
          return
        }
        this.leftItems = [...this.leftItems, ...item[this.props.children]]
        this.form.checkList = this.leftItems.map(item => item[this.props.id])
        item[this.props.children] = []
        item[this.props.checked] = []
        // item.checkAll = false
      }
    },
    handleCheckedFieldsChange (val, item) {
      console.log('val = ', val)
      let len = this.leftItems.length
      if (len >= +this.max && !this.groupCheckBox) {
        this.$alert(`查询条件最多显示${this.max}条`)
        return
      }
      let lastVal = val[len]
      let checkedCount = val.length
      if (item) {
        item.checkAll = checkedCount === item[this.props.children].length
        item.isIndeterminate = checkedCount > 0 && checkedCount < item[this.props.children].length
      }
      let id = this.props.id
      let leftItems = ((item && item[this.props.children]) || this.rightItems).filter(item => val.includes(item[id]))
      let index = ((item && item[this.props.children]) || this.rightItems).findIndex(item => val.includes(item[id]))
      item && item[this.props.children].splice(index, 1)
      item && item[this.props.checked].splice(0, 1)
      !item && this.rightItems.splice(index, 1)

      const lastFieldId = this.isFeiChe ? 1553 : 1648
      const changeFieldId = this.isFeiChe ? 4054 : 1402
      if (lastVal === lastFieldId) { // 时间区间
        let _index = this.leftItems.findIndex(item => +item[id] === changeFieldId)
        if (_index !== -1) {
          let _item = this.leftItems.find(item => +item[id] === changeFieldId)
          this.leftItems.splice(_index, 1)
          let _rightIndex = this.rightItems.findIndex(item => +item[id] === changeFieldId)
          _rightIndex === -1 && this.rightItems.push(_item)
        }
      } else if (lastVal === changeFieldId) { // 日期区间
        let __index = this.leftItems.findIndex(item => +item[id] === lastFieldId)
        if (__index !== -1) {
          let __item = this.leftItems.find(item => +item[id] === lastFieldId)
          this.leftItems.splice(__index, 1)
          let __rightIndex = this.rightItems.findIndex(item => +item[id] === lastFieldId)
          __rightIndex === -1 && this.rightItems.push(__item)
        }
      }

      this.leftItems = [...this.leftItems, ...leftItems]
      this.form.checkList = this.leftItems.map(item => item[id])
    },
    dragChange () {
      console.log(this.leftItems)
    },
    submit () {
      this.$emit('change', this.leftItems)
    },
    searchCheckBox () {
      let keyword = this.form.value
      if (!keyword) {
        return
      }
      const box = document.querySelectorAll('.search-condition')
      let index = 0
      const checkboxLabel = box[index].querySelectorAll('.el-checkbox__label')
      const activated = box[index].querySelectorAll('.activated')
      let array = [].slice.call(checkboxLabel)
      if (activated.length === 0) {
        this.originHtml = [...array]
      } else {
        this.clear()
      }

      array.forEach(element => {
        let text = element.innerHTML
        if (text.indexOf(keyword) !== -1) {
          let cut = text.split(keyword)
          element.innerHTML = cut.join(`<span class='activated'>${keyword}</span>`)
        }
      })
      this.smoothScroll('.activated')
    },
    smoothScroll (element) {
      let ele = document.querySelector(element)
      ele && ele.scrollIntoView({
        behavior: 'smooth'
      })
    },
    clear () {
      if (this.originHtml) {
        const box = document.querySelectorAll('.search-condition')
        const index = 0
        const checkboxLabel = box[index].querySelectorAll('.el-checkbox__label')
        let array = [].slice.call(checkboxLabel)
        array.forEach((element, index) => {
          let origin = this.originHtml.find(item => item.innerText === element.innerText)
          element.innerHTML = origin.innerText // this.originHtml[index].innerText
        })
      }
    }
  }
}
</script>

<style lang="less">
.search-condition{
  display: flex;
  &__search {
    display: flex;
    max-width: 320px;
    margin-bottom: 15px;
  }
  &__left{
    width: 40%;
    .el-checkbox{
      width: 100%-5%;
      padding: 5px 0;
      cursor: move;
      &+.el-checkbox{
        border-top: 1px solid #EAEAEA;
      }
    }
  }
  &__middle{
    position: absolute;
    height: calc(100% - 130px);
    left: 40%;
    top: 60px;
    width: 1px;
    background-color: #EAEAEA;
  }
  &__right{
    width: 60%;
    padding-left: 10px;
    .el-checkbox{
      width: 42%;
    }
    .el-icon-warning{
      color: #E6A23C;
      font-size: 16px;
    }
  }
  &__tips{
    padding-bottom: 20px;
  }
  &__checkbox{
    &__title{
      font-weight: bold;
      padding: 10px 0;
      .el-checkbox__label{
        font-weight: bold;
      }
    }
  }
  // &-box {
    .activated {
      background-color: yellow;
    }
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/finance/settlement/condition.vue